import { type SupportedProduct } from '@bingads-webui/ads-copilot-shared-types';

export interface IResponseSources {
  Title: string;
  Url: string;
}

export interface IResponseSiteLinks {
  DisplayName: string;
  Url: string;
}

/**
 * Represents a progress/status event emitted during request processing.
 * Matches MT contract: EventCallRecord
 */
export interface IEventCall {
  /** Machine-readable event name for categorization. Format: "{Source}.{Action}" */
  EventName: string;
  /** UTC timestamp for ordering events on the client */
  EventTimeStamp: string;
  /** User-facing progress message (may contain markdown, null if no message) */
  EventMessage: string | null;
  /** Reserved for future metadata (correlation IDs, re-classification hints) */
  EventMetaData: Record<string, unknown> | null;
}

/**
 * Matches MT contract: BotOutgoingMessageValue
 */
export interface IBotOutgoingMessageValue {
  QuestionId?: string;
  Sources?: IResponseSources[];
  SiteLinks?: IResponseSiteLinks[];
  StreamingStatus?: string;
  Intent?: string;
  IntentData?: unknown[];
  Features?: string[];
  PluginContext?: unknown;
  QuestionSuggestions?: unknown[];
  EventCalls?: IEventCall[];
}

// https://msasg.visualstudio.com/Bing_Ads/_git/AdsAppsMT?path=%2Fprivate%2FCampaign%2FMT%2FSource%2FAdsCopilot%2FAdsCopilotMT.Library%2FModel%2FStaticMessageFactory.cs
export type StaticMessageType = 'ResponsibleAI' | 'ConnectToAgent' | 'OutofScope' | 'LargePayload' | 'InternalError' | 'Welcome' | 'SignInError' | 'MissingArgumentsInPayload' | 'TurnLimitReached' | 'TokenExpired' | 'TokenExpiredAutoReload' | 'StreamingCancelled' | 'EmptyReplyToIdToCancelStreaming' | 'Timeout' | 'ConversationExpired' | 'InvalidPayload' | 'HandoffMessage' | 'ConversationResume' | 'SydneyResponsibleAI' | 'NoDataAvailable' | 'StreamingCompleted';

export interface IUserMessagePayload {
  BotFlightMode?: string;
  isHiddenFromUser?: boolean;
  Locale?: string;
  Product?: SupportedProduct;
  Timezone?: string;
  QuestionId?: string;
  UxContext?: any;
  Features?: string[];
  options?: object;
  AdditionalContext?: object;
  PluginContext?: any;
}

export type FeedbackType = 'ThumbsUp' | 'ThumbsDown' | 'None';

export interface ITokenApiPayload {
  userid: string;
  username: string;
}

export interface ITokenApiResponse {
  data: {
    conversationId: string;
    token: string;
    tokenExpiryInSeconds: number;
    userId: string;
    error: any;
  }
}

export type DirectLineErrorMessage = 'fetchTokenError' | 'directLineChannelError' | 'directLineExpiredToken' | string;
export interface IDirectLineError {
  message: DirectLineErrorMessage;
}

export const StreamingStatusType = {
  InProgress: 'InProgress',
  Completed: 'Completed',
  Cancelled: 'Cancelled',
};

export { type SupportedProduct };

// Mirrors server-side: Microsoft.Ads.CopilotMT.Model.ProductGroup
export enum ProductGroup {
  webui = 0,
  ucma = 1,
  ucmt = 2,
  xandr = 3,
  e2etest = 4,
  ads_marketing = 5,
  msads_landing_page = 6,
}
